module.exports = __webpack_public_path__ + "static/media/breakingbad.af954d2e.jpg";